import React, { Component } from "react";

export default class Dot extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			x: 0,
			y: 0
		};
	}

	logMousePosition = e => {
		this.setState({
			x: e.clientX,
			y: e.clientY
		});
	};
	componentDidMount() {
    	window.addEventListener("mousemove", this.logMousePosition);
    }
	render() {
		return (
			<div className="c-dot" style={{ left: this.state.x + 'px', top: this.state.y + 'px' }}>
				<div className="c-dot__left">
					<svg x="0px" y="0px" viewBox="0 0 32 32">
						<polygon points="20.48,0.1 22.01,1.48 8.7,16.31 22,30.7 20.49,32.1 5.92,16.33 "/>
					</svg>
				</div>
				<div className="c-dot__right">
					<svg x="0px" y="0px" viewBox="0 0 32 32">
						<polygon points="11.45,32.1 9.92,30.72 23.22,15.89 9.93,1.5 11.44,0.1 26.01,15.87 "/>
					</svg>
				</div>
			</div>
		);
  	}
}